export default __webpack_public_path__ + "static/mode-single-68901889f4bdab235e18c7e8fe7161d7.png";